import AsignadorFuncionService from 'src/modules/asignadorFuncion/asignadorFuncionService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';

const prefix = 'ASIGNADORFUNCION_FORM';

const asignadorFuncionFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: asignadorFuncionFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await AsignadorFuncionService.find(id);
      }

      dispatch({
        type: asignadorFuncionFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: asignadorFuncionFormActions.INIT_ERROR,
      });

      getHistory().push('/asignador-funcion');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: asignadorFuncionFormActions.CREATE_STARTED,
      });

      await AsignadorFuncionService.create(values);

      dispatch({
        type: asignadorFuncionFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.asignadorFuncion.create.success'),
      );

      getHistory().push('/asignador-funcion');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: asignadorFuncionFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: asignadorFuncionFormActions.UPDATE_STARTED,
      });

      await AsignadorFuncionService.update(id, values);

      dispatch({
        type: asignadorFuncionFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.asignadorFuncion.update.success'),
      );

      getHistory().push('/asignador-funcion');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: asignadorFuncionFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default asignadorFuncionFormActions;
